/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TimeClockFastIcon16Light } from './TimeClockFastIcon16Light';
import { TimeClockFastIcon16Regular } from './TimeClockFastIcon16Regular';
import { TimeClockFastIcon16Solid } from './TimeClockFastIcon16Solid';
import { TimeClockFastIcon20Light } from './TimeClockFastIcon20Light';
import { TimeClockFastIcon20Regular } from './TimeClockFastIcon20Regular';
import { TimeClockFastIcon20Solid } from './TimeClockFastIcon20Solid';
import { TimeClockFastIcon24Regular } from './TimeClockFastIcon24Regular';
import { TimeClockFastIcon24Solid } from './TimeClockFastIcon24Solid';
import { TimeClockFastIcon32Regular } from './TimeClockFastIcon32Regular';
import { TimeClockFastIcon64Regular } from './TimeClockFastIcon64Regular';
var sizes = {
    16: {
        light: TimeClockFastIcon16Light,
        regular: TimeClockFastIcon16Regular,
        solid: TimeClockFastIcon16Solid,
    },
    20: {
        light: TimeClockFastIcon20Light,
        regular: TimeClockFastIcon20Regular,
        solid: TimeClockFastIcon20Solid,
    },
    24: {
        regular: TimeClockFastIcon24Regular,
        solid: TimeClockFastIcon24Solid,
    },
    32: {
        regular: TimeClockFastIcon32Regular,
    },
    64: {
        regular: TimeClockFastIcon64Regular,
    },
};
export var TimeClockFastIcon = forwardRef('TimeClockFastIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
